export default "__VITE_ASSET__c2f800a3__"